import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { GiCrossedBones } from "react-icons/gi";
import { LuSave } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

const AddRole = () => {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Validation schema
    const validationSchema = Yup.object({
        roleName: Yup.string()
            .required("Role name is required")
            .min(2, "Role name must be at least 2 characters")
            .max(50, "Role name must not exceed 50 characters"),
        roleDescription: Yup.string()
            .required("Role description is required")
            .min(10, "Role description must be at least 10 characters")
            .max(200, "Role description must not exceed 200 characters"),
    });

    const initialValues = {
        roleName: "",
        roleDescription: "",
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            setIsSubmitting(true);

            // Simulate API call
            console.log("Submitting role data:", values);

            // TODO: Replace with actual API call
            // const response = await createRole(values);

            // Simulate API delay
            await new Promise(resolve => setTimeout(resolve, 1000));

            toast.success("Role created successfully!");
            resetForm();
            navigate("/admin/roles");
        } catch (error) {
            console.error("Error creating role:", error);
            toast.error("Failed to create role. Please try again.");
        } finally {
            setIsSubmitting(false);
            setSubmitting(false);
        }
    };

    return (
        <div className="formContainer p-5">
            <div className="flex flex-col mx-5 p-4 border rounded bg-white" style={{ boxShadow: "0px 0px 12px #cac8c8" }}>
                <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">Role Master</h5>
                {/* Formik Form */}
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting: formikSubmitting }) => (
                        <Form id="roleForm">
                            <div className="row">
                                <div className="col-md-6 w-1/2">
                                    <label className="form-label">Role Name</label>
                                    <Field 
                                        type="text" 
                                        name="roleName" 
                                        className="w-full px-3 py-2 shadow-[4px_4px_8px_rgba(0,0,0,0.3)] border border-gray-300 rounded-md focus:outline-none" 
                                    />
                                    <ErrorMessage name="roleName" component="div" className="text-danger" />
                                </div>
                                <div className="col-md-12 w-1/2 mt-3">
                                    <label className="form-label">Role Description</label>
                                    <Field 
                                        as="textarea" 
                                        name="roleDescription" 
                                        className="w-full px-3 py-2 shadow-[4px_4px_8px_rgba(0,0,0,0.3)] border border-gray-300 rounded-md focus:outline-none" 
                                        rows="4" 
                                    />
                                    <ErrorMessage name="roleDescription" component="div" className="text-danger" />
                                </div>
                            </div>

                            <div className="d-flex justify-content-start gap-3 mt-5 justify-content-center">
                                <button 
                                    type="submit" 
                                    className="saveButton d-flex" 
                                    disabled={isSubmitting || formikSubmitting}
                                >
                                    <span className="m-auto p-1"><LuSave /></span>{isSubmitting ? "Saving..." : "Save"}
                                </button>
                                <div className="flex gap-3">
                                    <button 
                                        type="button" 
                                        className="d-flex backButton d-flex" 
                                        onClick={() => navigate("/admin/roles")}
                                    > 
                                        <span className="m-auto p-1"><GiCrossedBones /></span>Cancel
                                    </button>
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default AddRole;
